module.exports = __webpack_public_path__ + "static/media/facebook_logobutton.71edaf0e.svg";